export default __webpack_public_path__ + "2815d8d989f625ff2d5d85a82e9b66c1.png";